export const ispeglaVreme = (vreme, tip) => {
    if (!vreme || vreme === '-' || vreme === '00:00') return '00:00';
    const delovi = vreme.split(':');
    const h = parseInt(delovi[0], 10);
    const m = parseInt(delovi[1], 10);
    const totalMin = h * 60 + m;
    if (tip === 'prijava' && totalMin >= 435 && totalMin <= 480) return '08:00';
    if (tip === 'odjava' && totalMin >= 950 && totalMin <= 965) return '16:00';
    const zaokruzenoM = Math.floor(m / 5) * 5;
    return `${String(h).padStart(2, '0')}:${String(zaokruzenoM).padStart(2, '0')}`;
};

export const decimalToTime = (decimalSati) => {
    if (decimalSati <= 0) return '00:00';
    const h = Math.floor(decimalSati);
    const m = Math.round((decimalSati - h) * 60);
    return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
};

export const izracunajSate = (p, o, naTerenu) => {
    if (!p || !o || p === '00:00' || o === '00:00') {
        return { ukupno: '00:00', redovno: '00:00', prekovremeno: '00:00', imaSati: false, ukupnoDec: 0, redovnoDec: 0, prekovremenoDec: 0 };
    }
    const [h1, m1] = p.split(':').map(Number);
    const [h2, m2] = o.split(':').map(Number);
    const diffMin = (h2 * 60 + m2) - (h1 * 60 + m1);
    let ukupnoDec = diffMin > 0 ? diffMin / 60 : 0;
    
    // Zaokruživanje na 5 minuta (1/12 sata)
    ukupnoDec = Math.round(ukupnoDec * 12) / 12;
    
    let redovnoDec, prekovremenoDec;
    
    // Ako je na terenu (Srbija ili Inostranstvo), sve ide u prekovremeno (terensko)
    if (naTerenu === 'Srbija' || naTerenu === 'Inostranstvo') { 
        redovnoDec = 0; 
        prekovremenoDec = ukupnoDec; 
    } else { 
        redovnoDec = ukupnoDec > 8 ? 8 : ukupnoDec; 
        prekovremenoDec = ukupnoDec > 8 ? ukupnoDec - 8 : 0; 
    }
    
    return { 
        ukupno: decimalToTime(ukupnoDec), 
        redovno: decimalToTime(redovnoDec), 
        prekovremeno: decimalToTime(prekovremenoDec), 
        imaSati: ukupnoDec > 0, 
        ukupnoDec, 
        redovnoDec, 
        prekovremenoDec 
    };
};

export const formatirajDatumSRB = (isoDatum) => {
    if (!isoDatum) return '';
    const [y, m, d] = isoDatum.split('-');
    return `${d}.${m}.${y}`;
};